import React from 'react';

import { Form, InputField } from 'components/Form';
import { Button, Dialog, DialogTitle } from 'components/Elements';
import { AtSign, User, X } from 'react-feather';

export const JoinWaitList = () => {
  const [show, setShow] = React.useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleOpen = () => {
    setShow(true);
  };

  return (
    <div className="">
      <div>
        <button
          onClick={handleOpen}
          className="bg-[#232323] text-white text-lg px-6 py-2 rounded-full hover:bg-gray-800 transition"
        >
          <span>Join waitlist</span>
        </button>
        <Dialog isOpen={show} onClose={handleClose} initialFocus={null}>
          <div className="inline-block align-bottom bg-[#26C4FF] dark:bg-gray-900 dark:text-gray-100 rounded-2xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <DialogTitle className="text-xl text-center font-bold mb-4 flex flex-row justify-between">
              <span className="text-gray-900">Join Our Waitlist</span>
              <button onClick={handleClose} className="bg-blue-100 text-[#26C4FF] rounded-full p-2">
                <X />
              </button>
            </DialogTitle>
            <div className="mb-6">
              Join our waitlist and get notified once our mobile app is fully available to
              customers.
            </div>
            <Form
              id="join-waitlist"
              onSubmit={async (values) => {
                await joinWaitlistMutation.mutateAsync({ data: values });
                handleClose();
              }}
            >
              {({ register, formState }) => (
                <>
                  <InputField
                    // label="Full Name"
                    name="fullName"
                    placeholder="Enter your full name"
                    required
                    icon={<User className="text-[#94e3ff]" />}
                    className="bg-[#26C4FF] border border-[#94e3ff] text-white placeholder:text-white placeholder:text-center text-center"
                    registration={register('fullName', { required: true })}
                  />
                  <InputField
                    // label="Email Address"
                    name="email"
                    type="email"
                    placeholder="Valid Email Address"
                    required
                    icon={<AtSign className="text-[#94e3ff]" />}
                    className="bg-[#26C4FF] border border-[#94e3ff] text-white placeholder:text-white placeholder:text-center text-center"
                    registration={register('email', { required: true })}
                  />
                  <button
                    type="submit"
                    className="w-full bg-[#232323] text-white py-4 hover:bg-gray-800 transition mt-4 rounded-full"
                  >
                    Join Now
                  </button>
                </>
              )}
            </Form>
          </div>
        </Dialog>
      </div>
    </div>
  );
};
